import { useState } from 'react'
import { useMyWork } from '../api/hooks'
import { useAuth } from '../auth/AuthProvider'
import { QuickAdd } from '../components/QuickAdd'
import { TaskDrawer } from '../components/TaskDrawer'
import { TaskGroup } from '../components/TaskRow'
import { EmptyState, ErrorNotice, Loading, PageHeader } from '../components/ui'

export function MyWorkPage() {
  const { user } = useAuth()
  const { data, isLoading, error } = useMyWork()
  const [openTaskId, setOpenTaskId] = useState<string | null>(null)
  const [showDone, setShowDone] = useState(false)

  const firstName = user?.name.split(' ')[0] ?? 'there'
  const overdueCount = data?.buckets.overdue.length ?? 0

  return (
    <>
      <PageHeader
        title={`Hello, ${firstName}`}
        subtitle={
          data
            ? overdueCount > 0
              ? `${data.openCount} open · ${overdueCount} overdue`
              : `${data.openCount} open task${data.openCount === 1 ? '' : 's'}`
            : undefined
        }
      />

      <QuickAdd defaultAssigneeId={user?.id} placeholder="What needs doing?" />

      {isLoading && <Loading />}
      {error && <ErrorNotice error={error} />}

      {data && (
        <>
          <TaskGroup
            title="Overdue"
            tone="danger"
            tasks={data.buckets.overdue}
            onOpen={setOpenTaskId}
          />
          <TaskGroup title="Today" tone="warn" tasks={data.buckets.today} onOpen={setOpenTaskId} />
          <TaskGroup title="This week" tasks={data.buckets.thisWeek} onOpen={setOpenTaskId} />
          <TaskGroup title="Later" tasks={data.buckets.later} onOpen={setOpenTaskId} />
          <TaskGroup title="No date" tasks={data.buckets.noDate} onOpen={setOpenTaskId} />

          {data.openCount === 0 && (
            <EmptyState
              title="Nothing assigned to you"
              description="When someone assigns you a task it will appear here, sorted by how soon it is due."
            />
          )}

          {data.recentlyDone.length > 0 && (
            <div className="mt-8">
              <button
                type="button"
                onClick={() => setShowDone((v) => !v)}
                className="mb-2 text-sm font-medium text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
              >
                {showDone ? 'Hide' : 'Show'} recently completed ({data.recentlyDone.length})
              </button>
              {showDone && (
                <TaskGroup title="Recently completed" tasks={data.recentlyDone} onOpen={setOpenTaskId} />
              )}
            </div>
          )}
        </>
      )}

      {openTaskId && <TaskDrawer taskId={openTaskId} onClose={() => setOpenTaskId(null)} />}
    </>
  )
}
